import PackshotGallery from "./PackshotGallery";

export default PackshotGallery;
